export const SITE_NAME = "Read by Ear";

// "read-by-ear", not "reader": ../app stamps this value, and keeping it keeps
// saved Axiom queries and monitors continuous across the cutover.
export const LOG_SERVICE_NAME = "read-by-ear";

export const STORAGE_PREFIX = "rbe-reader";

export function storageKey(suffix: string): string {
  return `${STORAGE_PREFIX}.${suffix}`;
}
